module.exports = __webpack_public_path__ + "img/u2.7491565f.jpg";